import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const VIRTUALIZED_LIST_ITEM_BUTTON_CLASS_NAME =
	'VirtualizedListItemButton';
export const VIRTUALIZED_LIST_ITEM_BUTTON_CLASS_SLOTS = ['root'] as const;

export type VirtualizedListItemButtonClassSlot =
	(typeof VIRTUALIZED_LIST_ITEM_BUTTON_CLASS_SLOTS)[number];

export interface VirtualizedListItemButtonClasses {
	root: string;
	isActive: string;
}

export type VirtualizedListItemButtonClassKey =
	keyof VirtualizedListItemButtonClasses;

export const getVirtualizedListItemButtonUtilityClass = (slot: string) =>
	generateUtilityClass(VIRTUALIZED_LIST_ITEM_BUTTON_CLASS_NAME, slot);

export const virtualizedListItemButtonClasses = generateUtilityClasses<
	keyof VirtualizedListItemButtonClasses
>(VIRTUALIZED_LIST_ITEM_BUTTON_CLASS_NAME, ['root', 'isActive']);

export default virtualizedListItemButtonClasses;
